import { IsArray, IsDefined, IsInt, IsNumber, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

export class CheckSupplierCodeExistsForMerchantGroupIdDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantGroupId: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  supplierId: number;

  @IsDefined()
  @IsString()
  supplierCode: string;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  excludeStockIds: number[];
}